import { z } from "zod"

import { pvWattsV8InputsSchema } from "./inputs"
import { pvWattsV8OutputsSchema } from "./outputs"
import { pvWattsV8SscInfoSchema } from "./sscInfo"
import { pvWattsV8StationInfoSchema } from "./stationInfo"

// https://developer.nlr.gov/docs/solar/pvwatts/v8/

export const pvWattsV8ResponseSchema = z.object({
  /**
   * The input parameters received in the request.
   * Type: collection
   */
  inputs: pvWattsV8InputsSchema,

  /**
   * Any error messages resulting from the request.
   * Type: array of strings
   */
  errors: z.array(z.string()),

  /**
   * Any warning messages resulting from the request.
   * Type: array of strings
   */
  warnings: z.array(z.string()),

  /**
   * The current version of the web service.
   * Type: string
   */
  version: z.string(),

  /**
   * Information about the SSC library.
   * Type: collection
   */
  ssc_info: pvWattsV8SscInfoSchema,

  /**
   * Information about the weather data used in the simulation.
   * Type: collection
   * See "station info fields" for more detail.
   */
  station_info: pvWattsV8StationInfoSchema,

  /**
   * The data outputs from the simulation.
   * Type: collection
   * See "output fields" for more detail.
   */
  outputs: pvWattsV8OutputsSchema,
})

export type PvWattsV8Response = z.infer<typeof pvWattsV8ResponseSchema>
